//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      detailId: null,
      dto: {},
      selectModel:'base'
    }
  },
  methods: {
    getDetail() {
      this.$loadingShow();
      this.$get('api/stock_table/' + this.detailId).then((data) => {
        this.dto = data;
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    changeShowModel(str){
      this.selectModel = str;
    },
    backSourceList() {
      this.$router.go(-1);
    },
    switchTabItem(orderDetail,i){
      this.$set(orderDetail,'list',i);
    }
  },
  mounted() {
    this.detailId = this.$route.params.id;
    this.getDetail();
  }
}



// WEBPACK FOOTER //
// ./src/page/asn/received-view/view.vue